import { useClientLogger } from '@coolblue-development/next-config/client';
import { getAllSelectedInstallationServices } from '@coolblue-development/next-installation-services/client';
import { CROSS_SELL_CHARGER_FIELD_NAME } from '@features/product/components/OrderBlock/UsbCCharger/constants';
import { addToCart } from '@utils/nextShoppingCartActions/addToCart';

import { TradeInType } from './types';

type InstallationServiceCartItem = {
  productId: string;
  accessoryId: string;
};

type SetIsLoading = React.Dispatch<React.SetStateAction<boolean>>;

export const onSubmitForm = async (
  formElement: HTMLFormElement,
  tradeIn: TradeInType,
  trackingEvent: () => void,
  setIsLoading: SetIsLoading,
  productId: number,
  quantity: number,
  logger: ReturnType<typeof useClientLogger>,
  secondChanceProductId?: string,
  secondChanceRedirectUrl?: string,
  addToCartRedirectUrl?: string,
  crossSell?: {
    onChargerAdded?: (chargerId: string) => void;
  }
) => {
  const formData = new FormData(formElement);

  const installationServices = getAllSelectedInstallationServices(formData);
  const accessoryPromotion = formData.getAll('accessoryPromotion')[0]?.toString();
  const tradeInValue = tradeIn.brandId > 0 ? tradeIn : undefined;
  const crossSellChargerProductId = formData.get(CROSS_SELL_CHARGER_FIELD_NAME);
  const chargerId = crossSellChargerProductId ? `${crossSellChargerProductId}` : undefined;

  try {
    const result = await addToCart({
      productId,
      quantity,
      installationServices: installationServices as InstallationServiceCartItem[],
      ...(accessoryPromotion && { accessoryPromotionProductId: accessoryPromotion }),
      ...(tradeInValue && { tradeIn: tradeInValue }),
      ...(secondChanceProductId && {
        secondChanceProductId: Number(secondChanceProductId),
        secondChanceRedirectUrl
      }),
      ...(chargerId && { crossSellChargerId: chargerId }),
      ...(addToCartRedirectUrl && { addToCartRedirectUrl })
    });

    if (chargerId && crossSell?.onChargerAdded) {
      crossSell.onChargerAdded(chargerId);
    }

    trackingEvent();

    if (result?.redirectUrl) {
      window.location.assign(result.redirectUrl);
    }
  } catch (error) {
    logger.error('Failed to add product to shopping cart', error as Error);
  } finally {
    setIsLoading(false);
  }
};
